import {useState} from 'react';
import {Button, ButtonProps} from '@mantine/core';
import {AiOutlineCopy} from 'react-icons/ai';

import {ProvisionPipelineDrawer} from '../drawers/ProvisionPipelineDrawer';
import {Pipeline} from '../types';

interface ClonePipelineButtonProps extends ButtonProps {
    pipeline: Pipeline;
}

// FNP-1017: "copy/clone from an existing pipeline exists as an alternative to
// re-picking options". Reuse on this platform is copy/clone of an existing
// definition — deliberately NOT a template layer, which was retired because
// every PIPELINE_TEMPLATE record was unreachable (findTemplateByArchetype could
// never match them) and there were zero of them in test and prod.
//
// A clone opens the SAME editable provision form, pre-filled from the source
// record instead of the analyzer. Nothing is applied blind: every field remains
// editable before provisioning, which is the whole point of this ticket. It also
// reuses the provisionPipeline mutation and its ProvisionPipeline RBAC action,
// so FNP-709's server-side prod-approval guardrail applies to a clone exactly as
// it does to a from-scratch provision.
export const ClonePipelineButton = ({pipeline, ...props}: ClonePipelineButtonProps) => {

    const [drawerOpened, setDrawerOpened] = useState(false);

    if (drawerOpened) {
        return (
            <ProvisionPipelineDrawer
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
                sourcePipeline={pipeline}
            />
        );
    }

    return (
        <Button
            leftSection={<AiOutlineCopy/>}
            onClick={() => setDrawerOpened(true)}
            {...props}
        >
            Clone
        </Button>
    );
};
